import {
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
} from '@mui/material';
import { authTokenKey } from 'authProvider';
import { ORG_ID, HOST } from 'config';
import { useRecordContext } from 'ra-core';
import React, { useState } from 'react';
import { buildUrl } from 'utils/url';
import GoogleIcon from '@mui/icons-material/Google';

export default function GoogleAuthButton() {
  const record = useRecordContext() || {};
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleAuth = async () => {
    try {
      setIsLoading(true);

      // Store current path to return to after OAuth
      localStorage.setItem('googleAuthOriginalPath', window.location.pathname + window.location.hash);

      const adminToken = localStorage.getItem(authTokenKey);
      const response1 = await fetch(buildUrl(HOST, ORG_ID ? `/org/${ORG_ID}` : '', '/auth/login/as'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${adminToken}`,
        },
        body: JSON.stringify({
          userId: record.id,
        }),
      });

      const { data: { token: userToken } } = await response1.json();

      // Store user token for OAuth callback
      localStorage.setItem('googleAuthUserToken', userToken);

      const response = await fetch(buildUrl(HOST, ORG_ID ? `/org/${ORG_ID}` : '', '/auth/oauth2/permission'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          permissions: ['youtube.readonly', 'youtubepartner-channel-audit'].join(','),
          redirectUri: window.location.origin,
        }),
      });

      if (response.ok) {
        const { data: { redirectUrl } } = await response.json();
        window.location.href = redirectUrl;
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Google auth failed:', error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={handleGoogleAuth}
        startIcon={<GoogleIcon />}
        disabled={isLoading}
      >
        Add Channel
      </Button>

      <Dialog
        open={isLoading}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p={3}
          >
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography variant="h6" color="white">
              Authorizing Google Account...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
